(function($) {
	let number_of_flights_edited = false;
	let uncover_to_point = false;
	let point_counter = 1;

	let $submit = $('.gform_footer *[type=submit]');
	let $left_col = $('.form-left-col-inner');
	let $logo = $('.site-header__logo');
	let $right_col = $('.form-right-col-inner');
	let $points = $('.point');
	let $flight_type = $('.js-flight-type select');
	let add_flight_text;
	let remove_flight_text;

	if ( typeof window.add_flight_text === 'string' && window.add_flight_text ) {
		add_flight_text = window.add_flight_text;
	}
	else {
		add_flight_text = 'Add next flight';
	}
	if ( typeof window.remove_flight_text === 'string' && window.remove_flight_text ) {
		remove_flight_text = window.remove_flight_text;
	}
	else {
		remove_flight_text = 'Remove this flight';
	}
	
	function show_point(point) {
		$('.add-point[data-point=' + point + ']').addClass('hidden');
		$('.remove-point[data-point=' + (point - 1) + ']').addClass('hidden');
		$('.point-' + point).removeClass('hidden').find('input')[0].focus();
	}

	function hide_point(point) {
		$('.point-' + point).addClass('hidden').find('input, textarea').val('');
		$('.remove-point[data-point=' + (point - 1) + ']').removeClass('hidden');
		$('.add-point[data-point=' + point + ']').removeClass('hidden').focus();
	}

	$submit.appendTo($right_col);
	$logo.prependTo($left_col);
	$points.each(function () {
		let $this = $(this);
		$this.addClass('point-' + point_counter);

		if (point_counter > 1) {
			$this.addClass('hidden');
			$this.append('<div class="remove-container"><a href="" class="remove-point" data-point="' + point_counter + '">' + remove_flight_text + '</a></div>');
		}

		if (point_counter < $points.length) {
			$this.append('<a href="" class="add-point" data-point="' + (point_counter + 1) + '">' + add_flight_text + '</a>');
		}

		// If the user refreshes the page, the values he/she previously entered will still be there, so we need to
		// display the additional flights up to the last one that contains any value
		$this.find('input:not(.gform_hidden)').each(function () {
			if ($(this).val()) {
				uncover_to_point = point_counter;
			}
		});
		point_counter++;
	});

	for (let i = 1; i <= uncover_to_point; i++) {
		show_point(i);
	}

	function display_2_flights_if_needed() {
		if ( number_of_flights_edited ) {
			return;
		}
		if ( uncover_to_point > 1 ) {
			return;
		}
		console.log(2);
		let val = $flight_type.find(":selected").text();
		console.log(val.includes('frakt') );
		if ( val.includes('frakt') || val.includes('pesial') ) {
			hide_point(2);
		}
		else {
			show_point(2);
		}
	}

	display_2_flights_if_needed();
	$flight_type.change(display_2_flights_if_needed);

	$('.add-point, .remove-point').click(function(e) {
		e.preventDefault();
	});
	$('.add-point').click(function() {
		show_point($(this).data('point'));
		number_of_flights_edited = true;
	});
	$('.remove-point').click(function() {
		hide_point($(this).data('point'));
		number_of_flights_edited = true;
	});
})(jQuery);
